import React from 'react';
import { Container, CssBaseline, Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import navbar from './../assets/navbar.png';
import CookiesSnackbar from './CookiesSnackbar';
import Footer from './Footer';

const useStyles = makeStyles(theme => ({
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: '64px'
  },
  navbarWrap: {
    textAlign: 'center'
  },
  navbar: {
    margin: '8px',
    maxWidth: '200px'
  }
}));

export default function(props: {
  children: React.ReactNode;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
  showFooter?: boolean;
  showHeader?: boolean;
}) {
  const classes = useStyles();
  return (
    <Container component="main" maxWidth={props.maxWidth || 'xs'}>
      <CssBaseline />
      {(props.showHeader === undefined || props.showHeader) && (
        <div className={classes.navbarWrap}>
          <img src={navbar} alt="UPlatforma" className={classes.navbar} />
        </div>
      )}
      <div className={classes.paper}>{props.children}</div>
      {(props.showFooter === undefined || props.showFooter) && (
        <Box mt={5}>
          <CookiesSnackbar />
          <Footer />
        </Box>
      )}
    </Container>
  );
}
